import { Injectable } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { NzNotificationService } from 'ng-zorro-antd/notification';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  constructor(private nzNotif: NzNotificationService, private translocoService: TranslocoService) { }

  show(iconType = 'error', message = '', title?: string, options?: object): void {
    const transTitle = this.translocoService.translate('SHARED.NOTIFICATION_HEADER');

    title = title || transTitle;
    this.nzNotif.create(iconType, title, message, options);
  }
}
